/**
 * Contact Form — Alpine.js component
 * Submits via admin-ajax.php and tracks the source page URL.
 */
export default function contactForm() {
    return {
        form: {
            name:       '',
            company:    '',
            email:      '',
            phone:      '',
            country:    '',
            message:    '',
            source_url: '',
            website:    '', // honeypot — must stay empty for real submissions
        },
        loading: false,
        success: false,
        error:   '',

        init() {
            // Capture the source page URL when the component initialises
            this.form.source_url = window.location.href;
        },

        validate() {
            if (!this.form.name.trim())  return 'Please enter your name.';
            if (!this.form.email.trim()) return 'Please enter your email address.';

            const emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRe.test(this.form.email)) return 'Please enter a valid email address.';

            if (!this.form.message.trim()) return 'Please describe your wastewater situation.';
            return null;
        },

        async submit() {
            if (this.loading) return;

            this.error = this.validate();
            if (this.error) return;

            this.loading = true;
            this.error   = '';

            const body = new FormData();
            body.append('action',     'vdz_contact');
            body.append('nonce',      window.vdzTrading?.nonce ?? '');
            body.append('form_token', window.vdzTrading?.formToken ?? '');

            Object.entries(this.form).forEach(([key, val]) => body.append(key, val));

            try {
                const historyStr = sessionStorage.getItem('vdz_user_history');
                if (historyStr) {
                    const history = JSON.parse(historyStr);
                    body.append('vdz_history_pages', JSON.stringify(history.pages || []));
                    body.append('vdz_unadded_products', JSON.stringify(history.products || []));
                    body.append('vdz_unadded_factories', JSON.stringify(history.factories || []));
                }
            } catch (e) {
                // Silently fail if storage is restricted
            }

            try {
                const res  = await fetch(window.vdzTrading?.ajaxUrl ?? '/wp-admin/admin-ajax.php', {
                    method: 'POST',
                    body,
                });
                const data = await res.json();

                if (data.success) {
                    this.success = true;
                } else {
                    this.error = data.data?.message ?? 'Something went wrong. Please try again.';
                }
            } catch {
                this.error = 'Network error. Please try again or call us directly at +31 (0)413-476070.';
            } finally {
                this.loading = false;
            }
        },
    };
}

